<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <VpnCallMenuButton ref='vpnMenuButton' @methodEnum='methodEnum' ></VpnCallMenuButton>
      <ChartDivCommon ref="chartDiv"></ChartDivCommon>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../../../layouts/BasicLayout';
import VpnCallMenuButton from '../../../../components/tsConfig/hytalkPro/VPNCallStatistics/VpnCallMenuButton';
import ChartDivCommon from '../../../../components/tsConfig/hytalkPro/VPNCallStatistics/ChartDivCommon';

export default {
  name: 'VPNCallStatisticsPage',
  components: {
    BasicLayout,
    VpnCallMenuButton,
    ChartDivCommon
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('组织架构呼叫次数')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.chartDiv.openQueryPage();
          break;
        case 'save':
          this.$refs.chartDiv.searchPage();
          break;
        case 'export':
          this.$refs.chartDiv.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
